import React, { useState, useEffect, useContext } from "react";

import "./BecomeASeller.css";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import classNames from "classnames";
import Common_Button from "../Common-Component/Common_Button/Common_Button";
import { Context } from "../../utils/context";
import { sellerRegistrationForm } from "../../utils/apis/common/Common";
import { Country, State, City, Pincode } from "../../utils/apis/master/Master";
import SuccessModal from "../Common_modal/Successfull_Modal/Successfull_Modal";

import { Category } from "../../utils/apis/Product/Product";
import { useNavigate } from "react-router-dom";
import SellerstepForm from "./SellerstepFormMain/SellerstepForm";

const BecomeASeller = () => {
  const { getData, IMG_URL, Select2Data } = useContext(Context);
  const [category, setCategory] = useState();
  const [countries, setCountries] = useState();
  const [states, setState] = useState();
  const [cities, setCity] = useState();
  const [pincodes, setPincode] = useState();
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview2, setImagePreview2] = useState(null);
  const [imageFile2, setImageFile2] = useState(null);
  const [imagePreview3, setImagePreview3] = useState(null);
  const [imageFile3, setImageFile3] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    watch,
    trigger,
    setValue,
  } = useForm();

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile([file]);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile(null);
      setImagePreview(null);
    }
  };
  const handleImageChange2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile2(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview2(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile2(null);
      setImagePreview2(null);
    }
  };
  const handleImageChange3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageFile3(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview3(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile3(null);
      setImagePreview3(null);
    }
  };

  const navigate = useNavigate();
  const onSubmit = async (data) => {
    if (data.password === data.c_password) {
      const fromData = new FormData();
      fromData.append("name", data?.name);
      fromData.append("contact_no", data?.contact_no);
      fromData.append("email", data?.email);
      fromData.append("pan_no", data?.pan_no);
      fromData.append("password", data?.password);
      fromData.append("c_password", data?.c_password);
      fromData.append("store_name", data?.store_name);
      fromData.append("tax_name", data?.tax_name);
      fromData.append("tax_no", data?.tax_no);
      fromData.append("country_id", data?.country_id?.value);
      fromData.append("state_id", data?.state_id?.value);
      fromData.append("city_id", data?.city_id?.value);
      fromData.append("pincode_id", data?.pincode_id?.value);
      fromData.append(
        "category_id",
        JSON.stringify(data?.category_id?.map((item) => item?.value))
      );
      fromData.append("n_identity_card", data?.national_identity_card[0]);
      fromData.append("address_proof", data?.address_proof[0]);
      fromData.append("logo", data?.logo[0]);
      const res = await sellerRegistrationForm(fromData);
      if (res?.success) {
        reset();
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          navigate("/");
        }, 3000);
      } else {
        if (res?.message?.both) {
          setError("email", { message: res?.message?.both });
          setError("contact_no", { message: "" });
        }
        if (res?.message?.email) {
          setError("email", { message: res?.message?.email });
        }
        if (res?.message?.contact_no) {
          setError("contact_no", { message: res?.message?.contact_no });
        }
        if (res?.message?.pan_no) {
          setError("pan_no", { message: res?.message?.pan_no });
        }
        if (res?.message?.tax_no) {
          setError("tax_no", { message: res?.message?.tax_no });
        }
      }
    } else {
      setError("password", {
        message: "Password Must Match",
      });
    }
  };
  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d$/.test(keyValue)) {
      event.preventDefault();
    }
  };
  const handleKeyPressPan = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (new RegExp("[A-Z]{5}[0-9]{4}[A-Z]{1}").test(keyValue)) {
      event.preventDefault();
    }
  };
  const getCategory = async () => {
    const res = await Category();
    if (res?.success) {
      const data = await Select2Data(res?.data, "category_id", false);
      setCategory(data);
    }
  };
  const getCountries = async () => {
    const res = await Country();
    if (res?.success) {
      const data = await Select2Data(res?.data, "country_id", false);
      setCountries(data);
    }
  };
  const getState = async (id) => {
    const res = await State(id);
    if (res?.success) {
      const data = await Select2Data(res?.data, "state_id", false);
      setState(data);
      setValue("state_id", "");
      setValue("city_id", "");
      setValue("pincode_id", "");
    }
  };
  const getCity = async (id) => {
    const res = await City(id);
    if (res?.success) {
      const data = await Select2Data(res?.data, "city_id", false);
      setCity(data);
      setValue("city_id", "");
      setValue("pincode_id", "");
    }
  };
  const getPincode = async (id) => {
    const res = await Pincode(id);
    if (res?.success) {
      const data = await Select2Data(res?.data, "pincode_id", false);
      setPincode(data);
      setValue("pincode_id", "");
    }
  };
  useEffect(() => {
    getCountries();
    getCategory();
  }, []);
  return (
    <>
      <section className="become-a-seller">
        <div className="container">
          <div className="row">
            <div className="col-xxl-12  col-xl-10 col-lg-12 col-md-12 mx-auto">
              <SellerstepForm />
            </div>
          </div>
        </div>
      </section>
      <SuccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message={"Seller Created SuccessFully"}
        subMessage={"Your details will be sent on email"}
      />
    </>
  );
};

export default BecomeASeller;
